import {
  Container,
  Box,
  Typography,
  Grid,
  TextField,
  Button,
} from "@mui/material";
import HomeLayout from "/layouts/HomeLayout";
import { useTranslation } from "react-i18next";

import { validateEmail } from "utils/functions";
import { createFeedback } from "context/actions/feedbacks";
import i18n from "i18next";
import CustomSnackBar from "components/CustomSnackBar";

import { GlobalContext } from "context";

// components
import WysiwygViewer from "components/TextEditorViewer";
import { useEffect, useState, useContext } from "react";
import LeafletMap from "components/LeafletMap";

const Content = ({}) => {
  const { state } = useContext(GlobalContext);

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [feedback, setFeedback] = useState("");
  const [success, setSuccess] = useState(false);
  const [errors, setErrors] = useState({
    name: false,
    email: false,
    feedback: false,
  });

  const [snack, setSnack] = useState({
    isOpen: false,
    msg: "",
    type: "success",
  });

  const onNameChange = (e) => setName(e.target.value);
  const onEmailChange = (e) => setEmail(e.target.value);
  const onFeedbackChange = (e) => setFeedback(e.target.value);

  const { t } = useTranslation();

  const [data, setData] = useState("");
  const [dataEng, setDataEng] = useState("");

  const handleFeedbackSend = async () => {
    let hasError = false;
    if (name.length === 0) {
      errors.name = true;
      hasError = true;
    } else {
      errors.name = false;
    }

    if (!validateEmail(email)) {
      errors.email = true;
      hasError = true;
    } else {
      errors.email = false;
    }

    if (feedback.length === 0) {
      errors.feedback = true;
      hasError = true;
    } else {
      errors.feedback = false;
    }

    setErrors({ ...errors });

    if (hasError) {
      if (!validateEmail(email))
        setSnack({
          isOpen: true,
          msg: t("invalid_email"),
          type: "error",
        });
      else
        setSnack({
          isOpen: true,
          msg: t("fill_form_full"),
          type: "error",
        });
      return;
    }

    const result = await createFeedback({
      name,
      email,
      feedback,
    });

    if (result.status === "success") {
      setSnack({
        isOpen: true,
        msg: t("send_successfully"),
        type: "success",
      });
      setName("");
      setEmail("");
      setFeedback("");
      setSuccess(true);
    }
  };

  const handleCloseSnack = () => {
    setSnack({ ...snack, isOpen: false });
  };

  return (
    <Container
      maxWidth="md"
      style={{
        paddingBottom: 16,
        paddingTop: 120,
        minHeight: "60vh",
      }}
    >
      <Grid container spacing={4}>
        <Grid
          item
          lg={6}
          md={6}
          sm={12}
          xs={12}
          style={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Typography variant={"h3"}>{t("send_offer")}</Typography>
          <TextField
            variant="outlined"
            style={{ marginTop: 20 }}
            placeholder={t("field.your_name")}
            value={name}
            onChange={onNameChange}
            error={errors.name}
          />
          <TextField
            variant="outlined"
            style={{ marginTop: 20 }}
            value={email}
            onChange={onEmailChange}
            error={errors.email}
            placeholder={t("field.mail")}
          />
          <TextField
            variant="outlined"
            style={{ marginTop: 20 }}
            placeholder={t("field.write_comment")}
            value={feedback}
            onChange={onFeedbackChange}
            multiline
            // rows={4}
            error={errors.feedback}
          />
          <Button
            style={{
              marginTop: 30,
              backgroundColor: "#007bff",
            }}
            onClick={handleFeedbackSend}
          >
            <Typography variant={"h4"} style={{ color: "#fff" }}>
              {t("field.send")}
            </Typography>
          </Button>
        </Grid>

        <Grid
          item
          lg={6}
          md={6}
          sm={12}
          xs={12}
          style={{
            display: "flex",
            flexDirection: "column",
            // marginBottom: 200,
          }}
        >
          <Typography variant={"h2"}>{t("contact")}</Typography>
          <Box className={"mt-4"}>
            {i18n.language === "en" ? (
              <Typography variant="h3">
                Blue Sky Tower, Peace avenue-17
                <br />
                Sukhbaatar district, Ulaanbaatar-14240
                <br />
                Tel: (976-51) 26 27 99, (976-51) 26 27 98
                <br />
                E-mail: info@regional.gov.mn
                <br />
                http: www.regional.gov.mn
              </Typography>
            ) : (
              <Typography variant="h3">
                Сүхбаатар дүүрэг, 1-р хороо, Нарны зам 59Г өргөтгөлд байрлах
                "ТЭУ" эмнэлэгийн 3 давхар, Ulaanbaatar, Mongolia
                <br />
                Утас: 7711 1918
                <br /> Цахим шуудан: Khanlor2021@gmail.com
                <br /> Цахим хаяг: https: hanlor.mn
              </Typography>
            )}
          </Box>
        </Grid>

        <Grid
          item
          lg={12}
          md={12}
          sm={12}
          xs={12}
          style={{
            display: "flex",
            flexDirection: "column",
            marginBottom: 140,
          }}
        >
          <LeafletMap />
        </Grid>
      </Grid>

      <CustomSnackBar
        open={snack.isOpen}
        msg={snack.msg}
        handleClose={handleCloseSnack}
        type={snack.type}
      />
    </Container>
  );
};

Content.Layout = HomeLayout;

export default Content;
